import * as React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import ConfigUtility from 'Core/ConfigUtility';

const Config = ConfigUtility.getSync()!;

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  config: any;
}

export default class ErrorMonitor extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      config: Config
    };
  }
  componentDidMount() {
    ConfigUtility.get().then(x=>
      {
        this.setState({ config: x});
      });
  }

  render() {
    let Wrapper = React.Fragment;
    if (Config?.EnableBugSnag) {
      const bugsnagClient = bugsnag(Config.BugSnagApiKey);
      bugsnagClient.use(bugsnagReact, React);
      const ErrorBoundary = bugsnagClient.getPlugin('react');
      Wrapper = ErrorBoundary;
    }

    return <Wrapper>{this.props.children}</Wrapper>;
  }
}
